import { defineMessages, useIntl } from 'react-intl';

import styles from '../Buybox/Buybox.module.scss';

const messages = defineMessages({
    specialUspLabel: { defaultMessage: 'Das Besondere:' },
});

type UspTextProps = {
    readonly uspText: string;
};

const UspText = ({ uspText }: UspTextProps): JSX.Element => {
    const intl = useIntl();
    const specialUspLabel = intl.formatMessage(messages.specialUspLabel);
    const specialUspLabelIndex = uspText.indexOf(specialUspLabel);

    return (
        <p className={styles.uspText}>
            {specialUspLabelIndex === -1 ? (
                uspText
            ) : (
                <>
                    {uspText.slice(0, specialUspLabelIndex)}
                    <span className={styles.specialUspLabel}>{specialUspLabel}</span>
                    {uspText.slice(specialUspLabelIndex + specialUspLabel.length)}
                </>
            )}
        </p>
    );
};

export { UspText };
